// removed by extract-text-webpack-plugin
module.exports = {"block":"_1etrF6658opt2YVoxn0p1u","image":"_3RTVlnUYX8Oh1jR_Ad8s60","icon":"_2Nfhkt_4yVe6x4F5W5mXly","title":"_2g7EoV-Be-sSj6HmuL9X9f","failed":"V_GnXbkW1YcITMarPJMpE","link":"_144yLxpjHFLblzFC3J4CfP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WebcamBlock/WebcamBlock.module.scss
// module id = 819
// module chunks = 0